import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import * as ProjectActionType from '../../constants';

class HomeDocumentSectionSharingFile extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    show: PropTypes.bool,
    onCloseModal: PropTypes.func,
    projectId: PropTypes.string,
    projectDocumentId: PropTypes.string,
    projectDocumentTypeId: PropTypes.string,
    ProjectDocumentSharedLot: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      lotCheckList: {}
    };
  }

  componentDidMount() {
    const { projectId, projectDocumentId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.GET_PROJECT_DOCUMENT_SHARE_LOT_ASYNC,
      params: {
        projectId,
        projectDocumentId
      },
      callback: this.onInitialLotCheckList
    });
  }

  onInitialLotCheckList = data => {
    const { sharedPhases } = data;

    let initialLotCheckList = {};

    sharedPhases.map(phase => {
      let lotIdList = {};

      phase.lots.map(lot => {
        lotIdList[lot.id] = lot.shared;
      });

      initialLotCheckList[phase.id] = lotIdList;
    });

    this.setState({
      lotCheckList: initialLotCheckList,
      sharedPhases
    });
  };

  onCloseModal = () => {
    this.props.onCloseModal();
  };

  onSave = () => {
    let addShareLots = [];
    let removeShareLots = [];

    const { lotCheckList } = this.state;

    const {
      ProjectDocumentSharedLot,
      projectId,
      projectDocumentId,
      projectDocumentTypeId
    } = this.props;

    const { sharedPhases } = ProjectDocumentSharedLot;

    let initialLotCheckList = {};

    sharedPhases.map(phase => {
      let lotIdList = {};

      phase.lots.map(lot => {
        lotIdList[lot.id] = lot.shared;
      });

      initialLotCheckList[phase.id] = lotIdList;
    });

    const phaseList = Object.keys(lotCheckList);

    phaseList.map(phaseId => {
      const lotList = Object.keys(lotCheckList[phaseId]);

      lotList.map(lotId => {
        if (
          lotCheckList[phaseId][lotId] !== initialLotCheckList[phaseId][lotId]
        ) {
          if (lotCheckList[phaseId][lotId]) {
            addShareLots.push({ phaseId, lotId });
          } else {
            removeShareLots.push({ phaseId, lotId });
          }
        }
      });
    });

    this.props.dispatch({
      type: ProjectActionType.UPDATE_PROJECT_DOCUMENT_SHARE_LOT_ASYNC,
      params: {
        projectId,
        projectDocumentId,
        projectDocumentTypeId,
        data: {
          addShareLots,
          removeShareLots
        }
      },
      callback: this.onCloseModal
    });
  };

  onCheckPhase = (e, value, data) => {
    const currentStateLotCheckList = { ...this.state.lotCheckList };

    let lotList = { ...currentStateLotCheckList[value] };

    Object.keys(lotList).map(item => {
      lotList[item] = data.checked;
    });

    currentStateLotCheckList[value] = lotList;

    const sharedPhases = [...this.props.ProjectDocumentSharedLot.sharedPhases];

    this.searchInput.value = '';

    this.setState({
      lotCheckList: currentStateLotCheckList,
      sharedPhases
    });
  };

  onCheckLot = (e, value, data) => {
    const phaseId = value.split(',')[0];
    const lotId = value.split(',')[1];
    const currentStateLotCheckList = { ...this.state.lotCheckList };

    currentStateLotCheckList[phaseId][lotId] = data.checked;

    this.setState({
      lotCheckList: currentStateLotCheckList
    });
  };

  onDetectPhaseCheckBoxStatus = phaseId => {
    const { lotCheckList } = this.state;

    const lotList = { ...lotCheckList[phaseId] };

    const lotListStatus = Object.values(lotList);

    if (!lotListStatus.includes(true)) {
      return -1;
    }

    if (!lotListStatus.includes(false)) {
      return 1;
    }

    return 0;
  };

  onKeyPressSearchInput = e => {
    if (e.key === 'Enter') {
      const searchValue = this.searchInput.value.toLowerCase();

      const currentSharedPhases = [
        ...this.props.ProjectDocumentSharedLot.sharedPhases
      ];

      let newSharedPhases = [];

      currentSharedPhases.map(phase => {
        const lotList = phase.lots;

        let itemSharedPhases = {
          id: phase.id,
          name: phase.name
        };

        let newLots = [];

        lotList.map(lot => {
          const { name, streetAddress } = lot;

          if (
            name.toLowerCase().includes(searchValue) ||
            streetAddress.toLowerCase().includes(searchValue)
          ) {
            newLots.push(lot);
          }
        });

        if (newLots.length) {
          itemSharedPhases['lots'] = newLots;

          newSharedPhases.push(itemSharedPhases);
        }
      });

      this.setState({
        sharedPhases: newSharedPhases
      });
    }
  };

  renderPhaseListSidebar = () => {
    const { sharedPhases } = this.props.ProjectDocumentSharedLot;

    return (
      <div className='phase-list'>
        <ul>
          {sharedPhases &&
            sharedPhases.map((item, index) => {
              const checkStatus = this.onDetectPhaseCheckBoxStatus(item.id);

              return (
                <li key={index}>
                  <CheckBoxSingle
                    ref={c => {
                      this.phase = c;
                    }}
                    checked={checkStatus === 1 ? true : false}
                    indeterminate={checkStatus === 0}
                    value={item.id}
                    label={item.name}
                    onChecked={this.onCheckPhase}
                    name='phase'
                    className='checkbox-default ckb-phase-pick'
                  />
                </li>
              );
            })}
        </ul>
      </div>
    );
  };

  renderMainLotList = sharedPhases => {
    const { lotCheckList } = this.state;

    return (
      <div className='main-lot-list'>
        <div className='lot-search-box form-group'>
          <input
            ref={ref => {
              this.searchInput = ref;
            }}
            className='form-control search-lot-input'
            placeholder='Lot# / Street address'
            onKeyPress={this.onKeyPressSearchInput}
          />
          <i className='fa fa-search search-lot-ic' />
        </div>

        <div className='lot-list'>
          {sharedPhases &&
            sharedPhases.map((item, index) => {
              return (
                <div className='lot-block' key={index}>
                  <p className='phase-header'>{item.name}</p>

                  <ul>
                    {item.lots.map((lot, i) => {
                      const currentChecked = lotCheckList[item.id]
                        ? lotCheckList[item.id][lot.id]
                        : false;
                      return (
                        <li key={i}>
                          <CheckBoxSingle
                            ref={c => {
                              this.lot = c;
                            }}
                            checked={currentChecked || false}
                            value={`${item.id},${lot.id}`}
                            label={`${lot.name}, ${lot.streetAddress}`}
                            onChecked={this.onCheckLot}
                            name='lot'
                            className='checkbox-default ckb-lot-pick'
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  render() {
    const { show } = this.props;

    const { sharedPhases } = this.state;

    return (
      <Modal show={show} className='sharing-file-with-lot-modal'>
        <p className='md-header'>Pick lots to share the file with</p>
        <div className='pick-lot-wrapper'>
          {this.renderPhaseListSidebar()}
          {this.renderMainLotList(sharedPhases)}
        </div>
        <div>
          <button className='btn btn-primary btn-siteone-default' onClick={this.onCloseModal}>Cancel</button>
          <button className='btn btn-primary btn-siteone' onClick={this.onSave}>Save</button>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    ProjectDocumentSharedLot: state.ProjectStore.ProjectDocumentSharedLot
  };
};

export default connect(mapStateToProps)(HomeDocumentSectionSharingFile);



// WEBPACK FOOTER //
// ./src/Projects/Components/Document/home-document-section-sharing-file.js